class TimeoutTimer {
    // eslint-disable-next-line @typescript-eslint/ban-types
    constructor(timeoutTime, fn) {
        this.timeoutTime = timeoutTime;
        this.fn = fn;
        this.timeoutRef = null;
    }
    stop() {
        if (this.timeoutRef) {
            clearInterval(this.timeoutRef);
            this.timeoutRef = null;
        }
        return this;
    }
    start() {
        if (!this.timeoutRef && this.timeoutTime > 0) {
            this.stop();
            this.timeoutRef = setTimeout(this.fn, this.timeoutTime);
        }
        return this;
    }
    reset() {
        return this.stop().start();
    }
}
export default TimeoutTimer;
//# sourceMappingURL=timeoutTimer.js.map